<template>
<div class="audit-pm25-ion-chart-wrapper">
  <div style="display:flex;justify-content:flex-end;gap:10px;padding:10px;">
    <site-query :sites="filterSites1" :query="query1" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </div>

  <pm25-ion
    :site-map="filterSiteMap"
    :factor-map="factorMap"
    :query="query"
    :data-list="dataList"
  />
</div>
</template>

<script>
import {mapGetters} from 'vuex'
import Pm25Ion from '../../../components/Data/Pm25Ion'
import SiteQuery from '../../../components/Data/Query/SiteQuery'

export default {
  name: 'Pm25IonChart',
  components: {SiteQuery, Pm25Ion},
  props: {
    site: {
      required: true,
      type: Object
    },
    factorMap: {
      required: true,
      type: Object
    },
    query: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    query1: {
      siteIds: []
    },
    dataList: Object.freeze([])
  }),
  computed: {
    ...mapGetters({
      profileSites: 'Profile/sites',
      profileSiteDevices: 'Profile/siteDevices'
    }),
    profileSiteDeviceMap () {
      return this.profileSiteDevices.reduce((map, siteDevice) => {
        map[siteDevice.id] = siteDevice
        return map
      }, {})
    },
    sites () {
      let profileSites = JSON.parse(JSON.stringify(this.profileSites))
      let profileSiteDeviceMap = this.profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let siteDevices = map[siteId]

        if (!Array.isArray(siteDevices)) {
          siteDevices = map[siteId] = []
        }

        siteDevices.push(siteDevice)

        return map
      }, {})

      profileSites.forEach(site => {
        site.devices = profileSiteDeviceMap[site.id] || []
      })

      return profileSites
    },
    filterSites () {
      const ionCategoryId = process.env.ION_DEVICE_CATEGORY

      return this.sites.reduce((list, site) => {
        let {id} = site

        let siteDevices = site.devices.filter(siteDevice => siteDevice.categoryId === ionCategoryId)

        if (siteDevices.length > 0) {
          list.push({
            id,
            name: site.name,
            devices: siteDevices
          })
        }

        return list
      }, [])
    },
    filterSiteMap () {
      return this.filterSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    filterSites1 () {
      let siteId = this.site.id
      return this.filterSites.filter(site => site.id !== siteId)
    },
    canNotSearch () {
      return this.query1.siteIds.length === 0
    }
  },
  methods: {
    requestData () {
      this.$store.commit('LoadStatus/status', true)

      let {query} = this

      this.$api.Data.getHistoryData({
        ...query,
        isMultipleIntegral: true,
        siteIds: query.siteIds.concat(this.query1.siteIds)
      }).then(dataList => {
        this.dataList = Object.freeze(dataList)
      }).catch(console.error).finally(() => {
        this.$store.commit('LoadStatus/status', false)
      })
    },
    onSearchBtnClick () {
      this.requestData()
    }
  },
  watch: {
    query: {
      immediate: true,
      handler () {
        this.requestData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.audit-pm25-ion-chart-wrapper {
  display: grid;
  grid-template-rows: max-content auto;
  width: 100%;
  height: 100%;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  /deep/ {
    .back-btn {
      top: -38px !important;
      left: 10px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/Pm25IonChart.vue